import React from 'react';
import Styles from './FJButton.module.less';
import FJLoading from '../FJLoading/FJLoading';
import classNames from 'classnames';

export default function FJButton(props) {
    const { onClick = () => {}, className = '', isLoading = false, disabled = false, children, ...restProps } = props;
    return (
        <button
            onClick={onClick}
            className={classNames(Styles.btn_container, className)}
            disabled={disabled || isLoading}
        >
            <span className={Styles.btn_content}>{isLoading ? <FJLoading loading={isLoading} /> : children}</span>
        </button>
    );
}
